// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fork Overlays Styles - CSS Module */
.u1Lcx1L2xz_RRIQ1wYrX {
  position: absolute;
  inset: 0;
  z-index: 32;
  pointer-events: none;
}

.S_OrYR3QHEHQxD4RRCS2 {
  position: absolute;
  transform: translateX(-50%);
  z-index: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.BZjDvb9u9yr5A1UvsCZT { transform: translateX(0); }
.fbZuYVzOeaAhzJZoJbto { transform: translateX(-100%); }

.Vcm71BVSJVIVfGrAMMkp {
  width: 1px;
  height: 6px;
  margin: 0 auto 2px;
}

.z1eRGSkZzxVPwT3YGWNx {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  white-space: nowrap;
  padding: 0;
  background: none;
  border: none;
}

.s9wqRxaRez8rFXmG5Iib {
  position: absolute;
  transform: translateX(-50%);
  z-index: 2;
}

.pJ1Fzyb097bIvgVJAz1g {
  width: 1px;
  height: 8px;
  margin: 0 auto 2px;
}

.RMCv7H3bmLCkbNqCqnFS {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  white-space: nowrap;
  padding: 2px 6px;
  border-radius: 3px;
  background: var(--vnsc-bg-secondary);
  border: none;
  color: var(--vnsc-text-primary);
}

.yZEru1t6bbIv5K7WizhI {
  position: absolute;
  left: 8px;
  z-index: 18;
  pointer-events: none;
  font-family: var(--gc-mono, monospace);
  font-size: 11px;
  line-height: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
}

.wy9qzJcdUvsF7L7nuz6A {
  background: none;
  border: none;
}

.lQs8mic505biyfe2a_Fp {
  background: none;
  border: none;
}

.qcqM091GY5qyAP964iFH {
  color: var(--vnsc-text-secondary, #64748b);
}

.SfNAlV9Jl_6ugV7wuBkn {
  color: var(--vnsc-text-primary, #1e2a3b);
}

.wy9qzJcdUvsF7L7nuz6A .qcqM091GY5qyAP964iFH {
  color: var(--vnsc-text-primary);
}

.wy9qzJcdUvsF7L7nuz6A .SfNAlV9Jl_6ugV7wuBkn {
  color: var(--vnsc-text-on-primary);
}

.HUC4QyzsPti4ioDtD94c {
  position: absolute;
  z-index: 22;
  pointer-events: none;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, monospace;
  font-size: 9px;
  font-weight: 500;
  line-height: 12px;
  white-space: nowrap;
  padding: 1px 3px;
  border-radius: 3px;
  transform: translateY(-50%);
  /* P0 handoff: số nhảy tick không co giãn bề ngang. */
  font-variant-numeric: tabular-nums;
}

/* UI-C: 1px subpane separator cutting across plot + axis column. */
.V7CqvSxBHLbwfikBI7rH {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));
  z-index: 15;
  pointer-events: none;
}

/* UI-C: indicator-pane Y labels get a badge backdrop to rank below price labels. */
.knQZVL4OO7fDg4f223Hr {
  background: var(--vnsc-bg-secondary, rgba(17, 24, 32, 0.85));
}

.tbvEf7Doiwsss_o7woxI {
  position: absolute;
  border: 1px dashed var(--vnsc-accent, rgba(56, 189, 248, 0.9));
  background: color-mix(in srgb, var(--vnsc-accent, rgba(56, 189, 248, 1)) 12%, transparent);
  pointer-events: none;
  z-index: 21;
}

.nb4gPrD6rCyIRBx45m6e {
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));
}

.HQ8Fa3DeLQJgrzmnStuK {
  height: var(--vnsc-bottom-panel-height, 260px);
  max-height: 60dvh;
  border-top: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  position: relative;
  z-index: 40;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

@media (max-width: 480px) {
  .z1eRGSkZzxVPwT3YGWNx,
  .RMCv7H3bmLCkbNqCqnFS {
    font-size: 9px;
    padding: 0 2px;
  }
  
  .yZEru1t6bbIv5K7WizhI {
    font-size: 10px;
    left: 4px;
    padding: 3px 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/fork-overlays.module.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;AACA,wBAAyB,wBAAwB,EAAE;AACnD,wBAA0B,4BAA4B,EAAE;;AAExD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qFAAqF;EACrF,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qFAAqF;EACrF,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,oFAAoF;EACpF,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yDAAyD;EACzD,WAAW;EACX,oBAAoB;AACtB;;AAEA,mFAAmF;AACnF;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,8DAA8D;EAC9D,0FAA0F;EAC1F,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,iDAAiD;EACjD,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE;;IAEE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;EAClB;AACF","sourcesContent":["/* Fork Overlays Styles - CSS Module */\r\n.forkXAxisOverlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 32;\r\n  pointer-events: none;\r\n}\r\n\r\n.forkXAxisTick {\r\n  position: absolute;\r\n  transform: translateX(-50%);\r\n  z-index: 1;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n.forkXAxisTickLeftEdge { transform: translateX(0); }\r\n.forkXAxisTickRightEdge { transform: translateX(-100%); }\r\n\r\n.forkXAxisTickLine {\r\n  width: 1px;\r\n  height: 6px;\r\n  margin: 0 auto 2px;\r\n}\r\n\r\n.forkXAxisTickLabel {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  line-height: 14px;\r\n  white-space: nowrap;\r\n  padding: 0;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.forkXAxisHoverLabel {\r\n  position: absolute;\r\n  transform: translateX(-50%);\r\n  z-index: 2;\r\n}\r\n\r\n.forkXAxisHoverLine {\r\n  width: 1px;\r\n  height: 8px;\r\n  margin: 0 auto 2px;\r\n}\r\n\r\n.forkXAxisHoverLabelText {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  line-height: 14px;\r\n  white-space: nowrap;\r\n  padding: 2px 6px;\r\n  border-radius: 3px;\r\n  background: var(--vnsc-bg-secondary);\r\n  border: none;\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.forkPaneTooltip {\r\n  position: absolute;\r\n  left: 8px;\r\n  z-index: 18;\r\n  pointer-events: none;\r\n  font-family: var(--gc-mono, monospace);\r\n  font-size: 11px;\r\n  line-height: 16px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 2px 8px;\r\n}\r\n\r\n.forkPaneTooltipDark {\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.forkPaneTooltipLight {\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.forkPaneTooltipLabel {\r\n  color: var(--vnsc-text-secondary, #64748b);\r\n}\r\n\r\n.forkPaneTooltipValue {\r\n  color: var(--vnsc-text-primary, #1e2a3b);\r\n}\r\n\r\n.forkPaneTooltipDark .forkPaneTooltipLabel {\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.forkPaneTooltipDark .forkPaneTooltipValue {\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.forkYAxisLabel {\r\n  position: absolute;\r\n  z-index: 22;\r\n  pointer-events: none;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, monospace;\r\n  font-size: 9px;\r\n  font-weight: 500;\r\n  line-height: 12px;\r\n  white-space: nowrap;\r\n  padding: 1px 3px;\r\n  border-radius: 3px;\r\n  transform: translateY(-50%);\r\n  /* P0 handoff: số nhảy tick không co giãn bề ngang. */\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* UI-C: 1px subpane separator cutting across plot + axis column. */\r\n.forkPaneSeparator {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  height: 1px;\r\n  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  z-index: 15;\r\n  pointer-events: none;\r\n}\r\n\r\n/* UI-C: indicator-pane Y labels get a badge backdrop to rank below price labels. */\r\n.forkYAxisLabelIndicator {\r\n  background: var(--vnsc-bg-secondary, rgba(17, 24, 32, 0.85));\r\n}\r\n\r\n.forkRubberBand {\r\n  position: absolute;\r\n  border: 1px dashed var(--vnsc-accent, rgba(56, 189, 248, 0.9));\r\n  background: color-mix(in srgb, var(--vnsc-accent, rgba(56, 189, 248, 1)) 12%, transparent);\r\n  pointer-events: none;\r\n  z-index: 21;\r\n}\r\n\r\n.forkLoadingOverlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 100;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));\r\n}\r\n\r\n.forkBottomPanel {\r\n  height: var(--vnsc-bottom-panel-height, 260px);\r\n  max-height: 60dvh;\r\n  border-top: 1px solid var(--vnsc-border, #2a2a2a);\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  position: relative;\r\n  z-index: 40;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .forkXAxisTickLabel,\r\n  .forkXAxisHoverLabelText {\r\n    font-size: 9px;\r\n    padding: 0 2px;\r\n  }\r\n  \r\n  .forkPaneTooltip {\r\n    font-size: 10px;\r\n    left: 4px;\r\n    padding: 3px 6px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forkXAxisOverlay": `u1Lcx1L2xz_RRIQ1wYrX`,
	"forkXAxisTick": `S_OrYR3QHEHQxD4RRCS2`,
	"forkXAxisTickLeftEdge": `BZjDvb9u9yr5A1UvsCZT`,
	"forkXAxisTickRightEdge": `fbZuYVzOeaAhzJZoJbto`,
	"forkXAxisTickLine": `Vcm71BVSJVIVfGrAMMkp`,
	"forkXAxisTickLabel": `z1eRGSkZzxVPwT3YGWNx`,
	"forkXAxisHoverLabel": `s9wqRxaRez8rFXmG5Iib`,
	"forkXAxisHoverLine": `pJ1Fzyb097bIvgVJAz1g`,
	"forkXAxisHoverLabelText": `RMCv7H3bmLCkbNqCqnFS`,
	"forkPaneTooltip": `yZEru1t6bbIv5K7WizhI`,
	"forkPaneTooltipDark": `wy9qzJcdUvsF7L7nuz6A`,
	"forkPaneTooltipLight": `lQs8mic505biyfe2a_Fp`,
	"forkPaneTooltipLabel": `qcqM091GY5qyAP964iFH`,
	"forkPaneTooltipValue": `SfNAlV9Jl_6ugV7wuBkn`,
	"forkYAxisLabel": `HUC4QyzsPti4ioDtD94c`,
	"forkPaneSeparator": `V7CqvSxBHLbwfikBI7rH`,
	"forkYAxisLabelIndicator": `knQZVL4OO7fDg4f223Hr`,
	"forkRubberBand": `tbvEf7Doiwsss_o7woxI`,
	"forkLoadingOverlay": `nb4gPrD6rCyIRBx45m6e`,
	"forkBottomPanel": `HQ8Fa3DeLQJgrzmnStuK`
};
export default ___CSS_LOADER_EXPORT___;
